/** Summary
 * Only for Michigan module,
 * in the case we add something similar for other states,
 * we should follow an approach similar to UMBI policies
 * https://www.figma.com/file/Z78Nkx9SGGZIosFSYia8Gr/branch/QB30Ivxzsw1Qnzb1UOgzrY/Staff?type=design&node-id=11809-267388&t=dz6oosvkJ8e5oVYI-0
 */

import React from 'react';

import HouseholdResidents from './household-residents';
import PipCoverages from './pip-coverages';

const PersonalInjuryProtection = () => {
  return (
    <>
      <HouseholdResidents />
      <PipCoverages />
    </>
  );
};

export default PersonalInjuryProtection;
